import isLink from './helpers/isLink';
import { addListActionFactory } from './factories/actions';
import reducerFactory from './factories/reducers';
import sFactory from './factories/selectors';
import groupBy from './helpers/groupBy';

export const reducersFactory = (contentTypeIds) => {
  const contentTypeReducers = contentTypeIds.reduce((acc, contenTypeId) => {
    acc[contenTypeId] = reducerFactory(contenTypeId);
    return acc;
  }, {});

  return {
    ...contentTypeReducers,
  };
};

const populateEntry = (entry, included, assets) => {
  const newItem = { ...entry.fields };
  Object.keys(newItem).forEach((key) => {
    const fieldContent = newItem[key];
    if (isLink(fieldContent)) {
      if (included[fieldContent.sys.id]) {
        const linkedEntry = included[fieldContent.sys.id];
        newItem[key] = populateEntry(linkedEntry, included, assets);
      } else if (assets[fieldContent.sys.id]) {
        const linkedAsset = assets[fieldContent.sys.id];
        newItem[key] = { ...linkedAsset };
      }
    } else if (Array.isArray(fieldContent)) {
      newItem[key] = fieldContent.map((nestedItem, i) => {
        if (typeof nestedItem === 'string') {
          return { id: i, title: nestedItem };
        }
        if (isLink(nestedItem)) {
          if (included[nestedItem.sys.id]) {
            const linkedEntry = included[nestedItem.sys.id];
            return populateEntry(linkedEntry, included, assets);
          }
          if (assets[nestedItem.sys.id]) {
            const linkedAsset = assets[nestedItem.sys.id];
            return { ...linkedAsset };
          }
        }
        return nestedItem;
      });
    }
  });
  newItem.contentType = entry.sys.contentType.sys.id;
  newItem.id = entry.sys.id;
  return newItem;
};

const handleEntries = (entries, included, assets) => (dispatch) => {
  const groupedEntries = groupBy(entries, item => item.sys.contentType.sys.id);
  // Now for each array of specific contentType we will dispatch 2 actions: `addListNews` and `addListEntry`
  Object.keys(groupedEntries).forEach((contentTypeId) => {
    const currentEntries = groupedEntries[contentTypeId];
    const completedEntries = currentEntries.map(entry => populateEntry(entry, included, assets));
    const addAction = addListActionFactory(contentTypeId);
    if (typeof addAction === 'function') {
      dispatch(addAction(completedEntries));
    }
  });
};

export const addResponse = response => (dispatch) => {
  const includes = response.includes && Array.isArray(response.includes.Entry)
    ? response.includes.Entry.reduce((acc, entry) => {
      acc[entry.sys.id] = entry;
      return acc;
    }, {})
    : {};
  const assets = response.includes && Array.isArray(response.includes.Asset)
    ? response.includes.Asset.reduce((acc, asset) => {
      const newAsset = {
        contentType: asset.fields.file.contentType,
        id: asset.sys.id,
        title: asset.fields.title,
        url: `https:${asset.fields.file.url}`,
      };
      acc[asset.sys.id] = newAsset;
      return acc;
    }, {})
    : {};
  dispatch(handleEntries(response.items, includes, assets));
};

export const selectorFactory = sFactory;



// WEBPACK FOOTER //
// ./src/store/contentfulRedux/index.js